(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laa-ai-film"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){var input=event.target;if(!input.matches('[data-ai-film-section] input[type="file"]'))return;input.setCustomValidity('');if(input.files.length&&input.files[0].size>10*1024*1024){input.setCustomValidity(input.closest('[data-ai-film-section]').dataset.fileError);input.reportValidity();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
